'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.Combobox', ['vs-repeat']).factory('ItemsListService', require('./services/ItemsListService')).factory('EventsService', require('./services/EventsService')).directive('rmCombobox', require('./directives/ComboboxDirective'));